import * as React from 'react';

function SvgWhatsapp(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.556 17.556" {...props}>
            <path
                data-name="Path 11702"
                d="M8.778 0a8.775 8.775 0 00-6.414 14.767l-1.953 1.84v.949h8.367A8.778 8.778 0 108.778 0zm0 16.423H2.251L3.993 14.8l-.609-.609a7.559 7.559 0 01-2.251-5.408 7.645 7.645 0 117.645 7.645z"
                fill="#fff"
            />
            <path
                data-name="Path 11703"
                d="M8.679 11.129a6.932 6.932 0 01-2.223-2.308l.949-.949V5.338H4.347a8.006 8.006 0 008.013 8.013v-3.044H9.5z"
                fill="#fff"
            />
        </svg>
    );
}

export default SvgWhatsapp;
